<template>
  <listTemplate :class="['height__100vh', 'scrollable-dialog']">
    <template #header>
      <headerTemplate>
        <template #filterByStatus>
          <div
            class="header-title wrapper-content__main font-size__large font-weight__bold"
          >
            Theo dõi kết luận chỉ đạo
          </div>
        </template>
      </headerTemplate>
    </template>

    <template #view>
      <div class="view">
        <list-template :classCustom="'list-docs wrapper-content__main'">
          <template #subHeader>
            <sub-header>
              <template #content>
                <div class="leftSection flex-row">
                  <el-button
                    size="small"
                    type="success"
                    v-if="isTonghopBaoCao"
                    @click="openCreateDialog"
                    class="margin-right-10"
                  >
                    <div class="flex-row flex__center">
                      <i class="fas fa-plus-circle font-size__medium"></i>
                      <span>&nbsp;&nbsp;Thêm mới</span>
                    </div>
                  </el-button>

                  <el-button-group class="flex-row">
                    <el-button
                      size="small"
                      type="primary"
                      @click="openReportTongHopDialog"
                      v-if="isAbleToExportTHReport"
                    >
                      <div class="flex-row flex__center">
                        <i class="fas fa-file-export font-size__medium"></i>
                        <span>&nbsp;&nbsp;BC tổng hợp</span>
                      </div>
                    </el-button>
                    <el-button
                      size="medium"
                      type="primary"
                      @click="openChiTietReportDialog"
                      v-if="isAbleToExportReport"
                    >
                      BC chi tiết
                    </el-button>
                  </el-button-group>
                </div>

                <searchTemplate
                  :keyword="keyword"
                  @simpleSearch="simpleSearch"
                  @search="isOpenAdvanceSearchDialog = true"
                >
                  <template #advance>
                    <hc-command-advance-search-dialog
                      :isOpen="isOpenAdvanceSearchDialog"
                      v-if="isEnableAdvanceSearchDialog"
                      :form="advanceSearchForm"
                      @dialogClosed="isEnableAdvanceSearchDialog = false"
                      @closeDialog="isOpenAdvanceSearchDialog = false"
                      @doSearch="advanceSearch"
                    >
                    </hc-command-advance-search-dialog>
                  </template>
                </searchTemplate>
              </template>
            </sub-header>
          </template>

          <template #body>
            <template>
              <div class="barChart" ref="barChartContainerDiv">
                <el-table
                  v-if="rerenderFlag"
                  :data="items"
                  class="style-fullWidth"
                  highlight-current-row
                  :height="chartSize.height"
                  sortable="custom"
                  @sort-change="doSort"
                  @row-click="viewDetail"
                >
                  <el-table-column type="index" fixed></el-table-column>

                  <el-table-column property="state" min-width="40" fixed>
                    <template slot-scope="scope">
                      <hc-command-state-icon :state="scope.row.state" />
                    </template>
                  </el-table-column>

                  <el-table-column
                    property="meeting"
                    label="Cuộc họp"
                    min-width="300"
                    fixed
                  >
                    <template slot-scope="scope">
                      <break-word-span
                        :text="scope.row.meeting"
                        :maxLength="100"
                      ></break-word-span>
                    </template>
                  </el-table-column>

                  <el-table-column
                    property="directiveFullName"
                    label="LĐ Chỉ đạo"
                    min-width="200"
                    sortable
                  >
                    <template slot-scope="scope">
                      <break-word-span
                        :text="scope.row.directiveFullName"
                        :maxLength="100"
                      ></break-word-span>
                    </template>
                  </el-table-column>

                  <el-table-column
                    property="performFullName"
                    label="LĐ phụ trách"
                    min-width="200"
                    sortable
                  >
                    <template slot-scope="scope">
                      <break-word-span
                        :text="scope.row.performFullName"
                        :maxLength="100"
                      ></break-word-span>
                    </template>
                  </el-table-column>

                  <el-table-column
                    label=" Ngày chỉ đạo"
                    property="commandsDate"
                    min-width="120"
                    sortable
                  >
                    <template slot-scope="scope">
                      <i class="el-icon-time"></i>
                      <span>{{
                        scope.row.commandsDate
                          | dateFormatter({
                            dateFormat: "DD/MM/YYYY",
                            nullValue: "-"
                          })
                      }}</span>
                    </template>
                  </el-table-column>

                  <el-table-column
                    label="Hạn hoàn thành"
                    property="deadline"
                    min-width="140"
                    sortable
                  >
                    <template slot-scope="scope">
                      <span>{{
                          getLastestDeadline(scope.row.deadline, scope.row.nextDeadline, scope.row.nextDeadline2)
                          | dateFormatter({
                            dateFormat: "DD/MM/YYYY",
                            nullValue: "-"
                          })
                      }}</span>
                    </template>
                  </el-table-column>

                  <el-table-column
                    property="sector"
                    label="Lĩnh vực"
                    min-width="150"
                  >
                    <template slot-scope="scope">
                      <break-word-span
                        :text="getSectorLabel(scope.row.sector)"
                        :maxLength="100"
                      ></break-word-span>
                    </template>
                  </el-table-column>

                  <el-table-column
                    property="conclusion"
                    label="Nội Dung"
                    min-width="300"
                  >
                    <template slot-scope="scope">
                      <break-word-span
                        :text="scope.row.conclusion"
                        :maxLength="100"
                      ></break-word-span>
                    </template>
                  </el-table-column>

                  <el-table-column
                    property="directionContent"
                    label="Ý kiến chỉ đạo"
                    min-width="300"
                  >
                    <template slot-scope="scope">
                      <break-word-span
                        :text="scope.row.directionContent"
                        :maxLength="100"
                      ></break-word-span>
                    </template>
                  </el-table-column>

                  <el-table-column
                    property="deptName"
                    label="ĐV thực hiện"
                    min-width="200"
                    sortable
                  >
                    <template slot-scope="scope">
                      <break-word-span
                        :text="scope.row.deptName"
                        :maxLength="100"
                      ></break-word-span>
                    </template>
                  </el-table-column>

                  <el-table-column
                    property="processType"
                    label="Vai trò"
                    min-width="100"
                  >
                    <template slot-scope="scope">
                      <break-word-span
                        :text="getProcessTypeLabel(scope.row.processType)"
                        :maxLength="50"
                      ></break-word-span>
                    </template>
                  </el-table-column>

                  <el-table-column
                    property="commandsStatus"
                    min-width="120"
                    label="Tiến độ xử lý"
                  >
                    <template slot-scope="scope">
                      <hc-command-status
                        :commandsStatus="scope.row.commandsStatus"
                      />
                    </template>
                  </el-table-column>

                  <el-table-column
                    property="progress"
                    min-width="120"
                    label="Đánh giá"
                  >
                    <template slot-scope="scope">
                      <hc-command-progress :progress="scope.row.progress" />
                    </template>
                  </el-table-column>

                  <el-table-column
                    label=" Ngày kết thúc "
                    min-width="140"
                    sortable
                    property="finishDate"
                  >
                    <template slot-scope="scope">
                      <i class="el-icon-time"></i>
                      <span>{{
                        scope.row.finishDate
                          | dateFormatter({
                            dateFormat: "DD/MM/YYYY",
                            nullValue: "-"
                          })
                      }}</span>
                    </template>
                  </el-table-column>

                  <el-table-column
                    prop="updateTime"
                    label="Ngày cập nhật"
                    min-width="140"
                    sortable
                  >
                    <template slot-scope="scope">
                      <i class="el-icon-time"></i>
                      <span>{{
                        scope.row.updateTime
                          | dateFormatter({
                            dateFormat: "DD/MM/YYYY",
                            nullValue: "-"
                          })
                      }}</span>
                    </template>
                  </el-table-column>

                  <!--                  <el-table-column fixed="right" width="120">-->
                  <!--                    <template slot-scope="scope">-->
                  <!--                      <el-button-->
                  <!--                        @click="viewDetail(scope.row)"-->
                  <!--                        type="text"-->
                  <!--                        size="small"-->
                  <!--                      >Chi tiết-->
                  <!--                      </el-button-->
                  <!--                      >-->
                  <!--                    </template>-->
                  <!--                  </el-table-column>-->

                  <infinite-loading
                    slot="append"
                    @infinite="infiniteHandler"
                    force-use-infinite-wrapper=".el-table__body-wrapper"
                    ref="infiniteLoading"
                  >
                    <div slot="no-more"></div>
                    <div slot="no-results"></div>
                  </infinite-loading>
                </el-table>
              </div>
            </template>
          </template>
        </list-template>
      </div>

      <hc-command-create-dialog2
        :isOpen="isOpenDialogCreate"
        v-if="isEnableDialogCreate"
        :flowId="flowId"
        :flowCode="flowCode"
        :parentDeptId="parentDeptId"
        @dialogClosed="isEnableDialogCreate = false"
        @closeDialog="isOpenDialogCreate = false"
        @insertSuccess="createDialogSuccess"
      />

      <hc-command-report-dialog
        :isOpen="isOpenDialogReport"
        v-if="isEnableDialogReport"
        @dialogClosed="isEnableDialogReport = false"
        @closeDialog="isOpenDialogReport = false"
        :inputForm="reportInputForm"
        :inputPageable="reportPageable"
      >
      </hc-command-report-dialog>

      <hc-command-report-th-dialog
        :isOpen="isOpenDialogReportTH"
        v-if="isEnableDialogReportTH"
        @dialogClosed="isEnableDialogReportTH = false"
        @closeDialog="isOpenDialogReportTH = false"
        :inputForm="reportTHInputForm"
      >
      </hc-command-report-th-dialog>
    </template>
  </listTemplate>
</template>

<script>
import headerTemplate from "../../../components/header/main-header.vue";
import menuConfigService from "../../../services/menuConfigService";
import listTemplate from "../../common/list";
import searchTemplate from "../../common/search";
import HcCommandReportDialog from "../../report/hcCommands/hc-command-report-dialog";
import HcCommandReportThDialog from "../../report/hcCommands/hc-command-report-th-dialog";
import mainContent from "./ketLuanChiDao_MainContent";
import utils from "../../../services/utils";
import h from "../../../services/h";
import hanhchinhService from "../../../services/hanhchinhService";
import hcCommandSearchViewService from "../../../services/hcCommandSearchViewService";
import HcCommandStateIcon from "./hc-command-state-icon";
import HcCommandStatus from "./hc-command-status";
import HcCommandProgress from "./hc-command-progress";
import dateFormatter from "../../../filters/dateFormatter";
import BreakWordSpan from "./break-word-span";
import HcCommandAdvanceSearchDialog from "./hc-command-advance-search-dialog";
import HcCommandCreateDialog2 from "./hc-command-create-dialog-2";
import hanhChinhUtils from "../../../services/hanhChinhUtils";
import goBackMixin from "../../../mixins/goBackMixin";
import SubHeader from "../../../components/main/sub-header";
import categoryViewService from "../../../services/categoryViewService";
import constants from "../../../constants";

export default {
  mixins: [goBackMixin],
  components: {
    HcCommandReportThDialog,
    HcCommandReportDialog,
    SubHeader,
    HcCommandCreateDialog2,
    HcCommandAdvanceSearchDialog,
    BreakWordSpan,
    HcCommandProgress,
    HcCommandStatus,
    HcCommandStateIcon,
    headerTemplate,
    searchTemplate,
    listTemplate,
    mainContent
  },
  filters: { dateFormatter },

  data() {
    return {
      isOpenAdvanceSearchDialog: false,
      isEnableAdvanceSearchDialog: false,
      isOpenDialogCreate: false,
      isEnableDialogCreate: false,
      isOpenDialogReport: false,
      isEnableDialogReport: false, //báo cáo chi tiết;
      isOpenDialogReportTH: false,
      isEnableDialogReportTH: false, //báo cáo tổng hợp
      reportInputForm: null,
      reportTHInputForm: null,
      reportPageable: null,

      selectdItem: null,
      flowId: null,
      hcFlow: null,
      flowCode: "CHI_DAO",

      advanceSearchForm: null,
      items: [],
      page: 0,
      size: 10,
      sort: "updateTime",
      order: "desc",
      keyword: null,
      chartSize: {
        width: 100,
        height: 100
      },
      rerenderFlag: false,
      sectorCategories: null,
      isAbleToExportReport: null,
      isAbleToExportTHReport: null
    };
  },

  computed: {
    userDeptRole() {
      return this.$store.getters.userDeptRole;
    },

    // isTongHopBaoCaoRole() {
    //   return (
    //     this.userDeptRole &&
    //     this.userDeptRole.roleCode === constants.ROLE.CODE.TONG_HOP_BAO_CAO
    //   );
    // },

    deptId() {
      return this.userDeptRole ? this.userDeptRole.deptId : null;
    },

    parentDeptId() {
      let userDeptRole = h.find(
        this.$store.state.userDeptRoles,
        userDeptRole => userDeptRole.id === this.$store.getters.userDeptRoleId
      );
      return userDeptRole.parentDeptId;
    },

    // childDeptId() {
    //   let userDeptRole = h.find(
    //     this.$store.state.userDeptRoles,
    //     userDeptRole => userDeptRole.id === this.$store.getters.userDeptRoleId
    //   );
    //   return userDeptRole.deptId;
    // }

    userDeptRoleId() {
      return this.$route.params.userDeptRoleId;
    },

    isTonghopBaoCao() {
      return this.$store.getters.userDeptRole && this.$store.getters.userDeptRole.roleCode === constants.ROLE.CODE.TONG_HOP_BAO_CAO;
    }
  },

  watch: {
    isOpenAdvanceSearchDialog(newValue) {
      newValue && (this.isEnableAdvanceSearchDialog = newValue);
    },

    isOpenDialogCreate(newValue) {
      newValue && (this.isEnableDialogCreate = newValue);
    },

    isOpenDialogReport(newValue) {
      newValue && (this.isEnableDialogReport = newValue);
    },

    isOpenDialogReportTH(newValue) {
      newValue && (this.isEnableDialogReportTH = newValue);
    },

    isEnableDialogCreate(newValue) {
      !newValue && (this.selectdItem = null);
    }
  },

  created() {
    if (!this.userDeptRoleId) return;
    this.loadSectorCategories();
    this.getProcedureInformation();
    this.initQuery();
    this.registerEventBusForMaster(event => this.doSearch());
    this.initActions();
  },

  destroyed() {
    this.unregisterEventBusForMaster();
  },

  mounted() {
    this.calculateChartSize();
    this.rerenderFlag = true;
  },

  methods: {
    initActions() {
      return Promise.all([
        menuConfigService
          .isEnableMenu(
            this.userDeptRoleId,
            constants.MENU_LIST.BAOCAO_HC_CHI_DAO_CHI_TIET
          )
          .then(isAccessible => (this.isAbleToExportReport = isAccessible)),
        menuConfigService
          .isEnableMenu(
            this.userDeptRoleId,
            constants.MENU_LIST.BAOCAO_HC_CHI_DAO_TONG_HOP
          )
          .then(isAccessible => (this.isAbleToExportTHReport = isAccessible))
      ]);
    },

    openChiTietReportDialog() {
      // console.log(this.advanceSearchForm.sector);
      //convert tham số lọc sang phần report;
      this.reportInputForm = {
        fromDeadline: this.advanceSearchForm.startTimeDeadline,
        toDeadline: this.advanceSearchForm.endTimeDeadline,
        fromCommandsDate: this.advanceSearchForm.startTimeCommand,
        toCommandsDate: this.advanceSearchForm.endTimeCommand,
        directiveIds: null,
        performIds: null,
        sectors: this.advanceSearchForm.sector
          ? [this.advanceSearchForm.sector]
          : null,
        commandStatusList: this.advanceSearchForm.commandsStatus
          ? [this.advanceSearchForm.commandsStatus]
          : null,
        progressStatus: null
      };
      this.reportPageable = { sort: this.sort, order: this.order };
      this.isOpenDialogReport = true;
    },

    openReportTongHopDialog() {
      this.reportTHInputForm = {
        fromDeadline: this.advanceSearchForm.startTimeDeadline,
        toDeadline: this.advanceSearchForm.endTimeDeadline,
        fromCommandsDate: this.advanceSearchForm.startTimeCommand,
        toCommandsDate: this.advanceSearchForm.endTimeCommand,
        directiveIds: null,
        performIds: null,
        sectors: this.advanceSearchForm.sector
          ? [this.advanceSearchForm.sector]
          : null,
        commandStatusList: this.advanceSearchForm.commandsStatus
          ? [this.advanceSearchForm.commandsStatus]
          : null,
        progressStatus: null
      };
      this.reportPageable = { sort: this.sort, order: this.order };
      this.isOpenDialogReportTH = true;
    },

    loadSectorCategories() {
      return categoryViewService
        .findAllByGroupCode(constants.CATEGORY_GROUP_CODE.HC_COMMAND_SECTOR)
        .then(response => (this.sectorCategories = response.data));
    },

    getProcessTypeLabel(processType) {
      return hanhChinhUtils.getHcCommandProcessTypeLabel(processType);
    },

    getSectorLabel(sector) {
      return hanhChinhUtils.getHcCommandSectorName(
        sector,
        this.sectorCategories
      );
    },

    openCreateDialog() {
      this.isOpenDialogCreate = true;
    },

    calculateChartSize() {
      this.chartSize.width = this.$refs.barChartContainerDiv.clientWidth;
      this.chartSize.height = this.$refs.barChartContainerDiv.clientHeight;
    },

    initQuery() {
      this.sort = this.$route.query.sort || "updateTime";
      this.order = this.$route.query.order || "desc";
      this.advanceSearchForm = {
        meeting: this.$route.query.meeting || undefined,
        sector: this.$route.query.sector || undefined,
        conclusion: this.$route.query.conclusion || undefined,
        directiveId: this.$route.query.directiveId || undefined,
        performId: this.$route.query.performId || undefined,
        deptId: this.$route.query.deptId || undefined,
        progress: this.$route.query.progress || undefined,
        state: this.$route.query.state || undefined,
        commandsStatus: this.$route.query.commandsStatus || undefined,

        startTimeCommand: this.$route.query.startTimeCommand
          ? parseInt(this.$route.query.startTimeCommand)
          : undefined,
        endTimeCommand: this.$route.query.endTimeCommand
          ? parseInt(this.$route.query.endTimeCommand)
          : undefined,
        startTimeDeadline: this.$route.query.startTimeDeadline
          ? parseInt(this.$route.query.startTimeDeadline)
          : undefined,
        endTimeDeadline: this.$route.query.endTimeDeadline
          ? parseInt(this.$route.query.endTimeDeadline)
          : undefined,
        startTimeFinish: this.$route.query.startTimeFinish
          ? parseInt(this.$route.query.startTimeFinish)
          : undefined,
        endTimeFinish: this.$route.query.endTimeFinish
          ? parseInt(this.$route.query.endTimeFinish)
          : undefined
      };

      this.keyword = this.advanceSearchForm.meeting;
    },

    buildQuery() {
      return utils.merge(
        { sort: this.sort, order: this.order },
        this.advanceSearchForm
      );
    },

    simpleSearch(keyword) {
      this.keyword = this.advanceSearchForm.meeting = keyword;
      this.advanceSearchForm.sector = undefined;
      this.advanceSearchForm.quote = undefined;
      this.advanceSearchForm.conclusion = undefined;
      this.advanceSearchForm.directiveId = undefined;
      this.advanceSearchForm.performId = undefined;
      this.advanceSearchForm.deptId = undefined;
      this.advanceSearchForm.progress = undefined;
      this.advanceSearchForm.state = undefined;
      this.advanceSearchForm.commandsStatus = undefined;
      this.advanceSearchForm.startTimeCommand = undefined;
      this.advanceSearchForm.endTimeCommand = undefined;
      this.advanceSearchForm.startTimeDeadline = undefined;
      this.advanceSearchForm.endTimeDeadline = undefined;
      this.advanceSearchForm.startTimeFinish = undefined;
      this.advanceSearchForm.endTimeFinish = undefined;
      this.doSearch();
    },

    advanceSearch(event) {
      let advanceSearchForm = event.advanceSearchForm;
      this.keyword = this.advanceSearchForm.meeting = advanceSearchForm.meeting;
      this.advanceSearchForm.sector = advanceSearchForm.sector || undefined;
      this.advanceSearchForm.quote = advanceSearchForm.quote || undefined;
      this.advanceSearchForm.conclusion =
        advanceSearchForm.conclusion || undefined;
      this.advanceSearchForm.directiveId =
        advanceSearchForm.directiveId || undefined;
      this.advanceSearchForm.performId =
        advanceSearchForm.performId || undefined;
      this.advanceSearchForm.deptId = advanceSearchForm.deptId || undefined;
      this.advanceSearchForm.progress = advanceSearchForm.progress || undefined;
      this.advanceSearchForm.state = advanceSearchForm.state || undefined;
      this.advanceSearchForm.commandsStatus =
        advanceSearchForm.commandsStatus || undefined;
      this.advanceSearchForm.startTimeCommand =
        advanceSearchForm.startTimeCommand || undefined;
      this.advanceSearchForm.endTimeCommand =
        advanceSearchForm.endTimeCommand || undefined;
      this.advanceSearchForm.startTimeDeadline =
        advanceSearchForm.startTimeDeadline || undefined;
      this.advanceSearchForm.endTimeDeadline =
        advanceSearchForm.endTimeDeadline || undefined;
      this.advanceSearchForm.startTimeFinish =
        advanceSearchForm.startTimeFinish || undefined;
      this.advanceSearchForm.endTimeFinish =
        advanceSearchForm.endTimeFinish || undefined;
      this.advanceSearchForm.directiveIds = advanceSearchForm.directiveIds || undefined;
      this.advanceSearchForm.performIds = advanceSearchForm.performIds || undefined;
      this.doSearch();
    },

    doSort(event) {
      this.sort = event.prop;
      switch (event.order) {
        case "ascending":
          this.order = "asc";
          break;
        case "descending":
          this.order = "desc";
          break;
        default:
          this.order = null;
      }
      this.doSearch();
    },

    doSearch() {
      this.$router.replace({
        name: this.$route.name,
        params: this.$route.params,
        query: this.buildQuery()
      });
      this.items = [];
      this.page = 0;
      this.$nextTick(() => {
        this.$refs.infiniteLoading &&
          this.$refs.infiniteLoading.stateChanger.reset();
      });
    },

    infiniteHandler($state) {
      this.list().then(items => {
        this.page += 1;
        items && items.length ? $state.loaded() : $state.complete();
      });
    },

    list() {
      let pageable = {
        page: this.page,
        size: this.size,
        sort: [this.sort, this.order].join(",")
      };
      return this.listIfHasTongHopBaoCaoRole(pageable).then(response => {
        let items = response.data;
        items && this.items.push(...items);
        return items;
      });
    },

    listIfHasTongHopBaoCaoRole(pageable) {
      // return hanhchinhService
      //   .getProcedureInformation(this.flowCode)
      //   .then(response => {
      //     let flow = response.data.hcFlow;
      //     flow === null && (this.search.deptId = this.childDeptId);
      //   })
      //   .then(() =>
      //     hcCommandSearchViewService.findAll(this.advanceSearchForm, pageable)
      //   );
      return hcCommandSearchViewService.findAll(
        this.advanceSearchForm,
        pageable
      );
    },

    // listIfHasDauMoiBaoCaoRole(pageable) {
    //   return hcCommandSearchViewService.findAllForDonVi(
    //     this.advanceSearchForm,
    //     pageable
    //   );
    // },

    getProcedureInformation() {
      return hanhchinhService
        .getProcedureInformation(this.flowCode)
        .then(response => {
          if (response.data.hcFlow !== null) {
            this.hcFlow = response.data.hcFlow;
            this.flowId = this.hcFlow.id;
          }
        });
    },

    reloadPage() {
      this.doSearch();
    },

    viewDetail(row, column, event) {
      let caseMasterId = row.caseMasterId;
      let params = utils.merge(this.$route.params, { id: caseMasterId });
      this.$router.push({
        name: "adminstration-concludeDetail",
        params: params,
        query: this.$route.query
      });
    },

    closeDialog() {
      this.isOpenDialogCreate = false;
    },

    createDialogSuccess() {
      this.isOpenDialogCreate = false;
      this.reloadPage();
    },

    getLastestDeadline(deadline, nextDeadline, nextDeadline2) {
      let lastestDeadline = null;
      if (nextDeadline2) {
        console.log('nextDeadline2', nextDeadline2)
        lastestDeadline = nextDeadline2;
      } else if (nextDeadline) {
        console.log('nextDeadline', nextDeadline)
        lastestDeadline = nextDeadline;
      } else {
        console.log('deadline', deadline)
        lastestDeadline = deadline
      }
      console.log('---------lastestDeadline', lastestDeadline)
      return lastestDeadline;
    }
  }
};
</script>

<style scoped>
.barChart {
  margin-top: 20px;
  height: calc(100% - 100px) !important;
  width: calc(100% - 10px) !important;
  position: relative;
}

.break-word {
  word-break: break-word;
}
</style>



// WEBPACK FOOTER //
// src/views/adminstration/ketluan/ketLuanChiDao_Index.vue